import { AuthService } from './../providers/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { IndexDBService } from "./../providers/indexdb.service";
import { WeixinService } from './weixin/weixin.service';
import { SysconfigService } from './../services/sysconfig.service';
@Component({
    selector: 'app',
    encapsulation: ViewEncapsulation.None,
    styles: [require('./app.component.css')],
    template: '<router-outlet></router-outlet>',
    providers: [
        WeixinService, SysconfigService
    ]
})
export class AppComponent implements OnInit {
    public angularclassLogo = '';
    public name = '';
    public url = '';

    public static indexDBFlag: boolean = false;
    constructor(
        private router: Router,
        private auth: AuthService,
        private wxCtrl: WeixinService,
        private sysService: SysconfigService,
        private indexDBService: IndexDBService,
    ) {
        this.indexDBService.openDataBase("LotteryDB", 1).then(() => {
            console.log("indexDB open success");
            AppComponent.indexDBFlag = true;
        });

        this.wxCtrl.GetWxSettingsHideAppsecret().then((res: any) => {
            if (res) {
                this.wxCtrl.SetWxSettings(res);
            }
        }).catch((error) => {
            console.log(error);
        });
    }
    public ngOnInit() {
        // this.mobilePC();
    }

    //判断是否为手机端登陆
    mobilePC() {
        function isPC() {
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
        if (isPC()) {
            //判断是否为谷歌浏览器
            // if (navigator.userAgent.indexOf('Chrome') < 0) { 
            //     this.router.navigateByUrl('explorer'); 
            // } 
            // var userAgent = navigator.userAgent;
            // var isOpera = userAgent.indexOf("Opera") > -1;

            // if (window.navigator.userAgent.indexOf("MSIE") >= 1 && userAgent.indexOf("Safari") < 0) {
            //     this.router.navigateByUrl('explorer');
            // }
            let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串 
            let isOpera = userAgent.indexOf("Opera") > -1;
            let isIE11 = (/Trident\/7\./).test(navigator.userAgent);//判断是否IE11
            let isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
            let isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器 
            let isSafari = userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器 
            let isChrome = userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1 && !isEdge; //判断Chrome浏览器
            let isIE = userAgent.indexOf("MSIE") > -1; //判断是否IE10以及一下浏览器
            if (isIE) {
                this.router.navigateByUrl('explorer');
            }
        } else {
            let autourlMobel = [];
            this.sysService.getPlatformLineList().then(res => {
                if (res) {
                    res.forEach(url => {
                        if (url.LineType == 3) {
                            autourlMobel.push(url.LineUrl);
                        }
                    });
                    let code = window.location.href.split("register=")[1];
                    if (location.href.indexOf('regist') >= 0) {
                        location.href = autourlMobel[0] + "/register?register=" + code;
                    }
                }
            })
        }
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/app.component.ts